import React from 'react'
import { Checkbox, Hint } from '@tecsinapse/cortex-react'
import { useController, useFormContext } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'

interface FormCheckboxFieldProps {
  name: string
  label: string
  disabled: boolean
  customOnBlur?: (e: React.FocusEvent<HTMLInputElement, Element>) => void
}

export const FormCheckboxField = ({
  name,
  label,
  customOnBlur,
  disabled
}: FormCheckboxFieldProps) => {
  const { control, setValue } = useFormContext()
  const {
    field: { value, onBlur },
    formState: { submitCount, errors },
    fieldState: { isTouched, error }
  } = useController({ control, name })

  return (
    <div className='w-full'>
      <label className='flex items-center space-x-2'>
        <Checkbox
          checked={value}
          onBlur={e => {
            onBlur()
            if (customOnBlur) customOnBlur(e)
          }}
          onChange={() => {
            setValue(name, !value, {
              shouldDirty: true,
              shouldValidate: true,
              shouldTouch: true
            })
          }}
          disabled={disabled}
        />
        <span className='text-black'>{label}</span>
      </label>
      {(isTouched || submitCount > 0) && error ? (
        <ErrorMessage
          name={name}
          errors={errors}
          render={({ message }) => (
            <Hint variants={{ intent: 'error' }}>{message}</Hint>
          )}
        />
      ) : null}
    </div>
  )
}
